import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Container, Row } from "reactstrap";
import SVG from "../SVG";
import { PropsTypes } from "../../Type/Layout/CommonElements/Breadcrumbs";
import H3 from "../Headings/H3Element";
import P from "../Paragraph";
import { useState } from "react";

const Breadcrumbs = ({ mainTitle, parent, ChildName }: PropsTypes) => {
  const [MemberName] = useState(localStorage.getItem("MemberName"));
  const [UserName] = useState(localStorage.getItem("UserName"));
  return (
    <Container fluid>
      <Row
        className={
          mainTitle === "Dashboard"
            ? "page-title align-items-center p-2"
            : "page-title align-items-center"
        }
      >
        <div
          className={
            mainTitle === "Dashboard"
              ? "col-12 col-md-12 order-1 bgimage"
              : "col-md-8 col-12"
          }
        >
          {mainTitle === "Dashboard" ? (
            <>
              <H3 className="DownloadBtnPara">Welcome Back, {MemberName}</H3>
              {/* <P className="text-start  text-white">UserID: {UserName} </P> */}
            </>
          ) : (
            <H3 className="text-start mb-0 text-black">{mainTitle}</H3>
          )}
        </div>
        {/* <div className={mainTitle === "Dashboard" ? 'block col-md-4 col-xl-4 order-md-2 order-3' : 'd-none'}>
          <div className="justify-content-end d-md-flex d-block">
            <div className="w-100">
                    <P className="text-start  text-black">Welcome, {MemberName}</P>
              </div>
          </div>
        </div> */}
        <div
          className={
            mainTitle === "Dashboard"
              ? "col-12 mb-3 mb-md-0 col-md-4 col-xl-4 order-md-3 order-1 d-none"
              : "col-md-4 col-12 text-end"
          }
        >
          <Breadcrumb className="justify-content-end align-items-center">
            <BreadcrumbItem>
              <Link to={`${import.meta.env.BASE_URL}`}>
                <SVG iconId="Home" className="svg-color" />
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>{parent}</BreadcrumbItem>
            {ChildName ? (
              <BreadcrumbItem className="active">{ChildName}</BreadcrumbItem>
            ) : undefined}
          </Breadcrumb>
        </div>
      </Row>
    </Container>
  );
};

export default Breadcrumbs;
